import { useMutation, UseMutationOptions, useQuery, useQueryClient } from 'react-query'
import { CheckInsApi } from '@trybeapp/sdk.customer'
import { useCurrentSiteId } from 'contexts/SiteConfig'
import { ApiResponse, LegacySdkResponseError, PaginatedApiResponse } from 'api/api.types'

const api = new CheckInsApi()

export const useCheckIn = (siteId: string) => {
  const queryClient = useQueryClient()

  return useMutation<any, LegacySdkResponseError, [string, Record<string, string>]>(
    ([customerId, vals]) =>
      api.createCheckIn({
        createCheckInRequest: {
          customer_id: customerId,
          site_id: siteId,
          ...vals,
        },
      }),
    {
      onSuccess: ({ data: checkIn }) => {
        queryClient.invalidateQueries(['checkIns', { customerId: checkIn.customer.id, siteId }])
        queryClient.invalidateQueries(['checkIns', { siteId }])
      },
    }
  )
}

export const useListCheckIns = (customerId?: string, siteId?: string, options = {}) =>
  useQuery(
    ['checkIns', { customerId, siteId }],
    () => api.listCheckIns({ customerId, siteId }),
    options
  )

export const useListAllCheckIns = (params = {}) => {
  const siteId = useCurrentSiteId()

  return useQuery<PaginatedApiResponse<Record<string, any>>, LegacySdkResponseError>(
    ['checkIns', { siteId, ...params }],
    () => api.listCheckIns({ siteId, ...params })
  )
}

export const useListAllCheckInsQueued = (
  options: UseMutationOptions<ApiResponse<any>, LegacySdkResponseError, Record<string, any>> = {}
) => {
  const siteId = useCurrentSiteId()

  return useMutation<ApiResponse<any>, LegacySdkResponseError, Record<string, any>>(
    (filters) => api.queueListCheckIns({ siteId, ...filters }),
    options
  )
}
